import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { Col, Form, Input, Modal, Row } from 'antd';
import debounce from 'debounce';

import { URL_ENDPOINT } from '../../index';

const FormItem = Form.Item;

class AddCategoryModal extends React.Component{

	props : {
		handleCloseModal():void,
		handleConfirm():void,
		onChange():void,
		onErrorHandler( error: boolean ):void,
		value:string,
		title:string,
		visible:boolean
	}

	render(){
		
		const { categoryMap } = this.state;
		const value = this.props.value || '';

		// if(!this.props.visible){
		// 	return null;
		// }

		return (
			<Modal
				onCancel={this.props.handleCloseModal}
				onOk={this.props.handleConfirm}
				visible={this.props.visible}
				footer={(
					<Row>
						<Col>
							<strong>Press [ENTER] to confirm.</strong>
						</Col>
					</Row>
				)}
				title={this.props.title}>

				<Form>
					<FormItem
						validateStatus={ categoryMap[value.toLowerCase()] ? "error": "success" }
						help={ categoryMap[value.toLowerCase()]? `${value} already exist` : "" }
					>

						{this.renderInput(value)}
						
					</FormItem>
				</Form>

				
				{
					this.props.value?
					this.state.existingCategories.map(
						(category, i) => <p key={i}>{category}</p>
					):
					''	
				}

			</Modal>
		)
	}

	renderInput = (value) => {
		if(this.state.loadingInput){
			return null;
		}

		return(
			<Input
			autoFocus
			placeholder="Category Title"	
			onPressEnter={this.props.handleConfirm}
			value={value}
			onChange={this.handleOnChange} />
		)
	}

	state = {
		existingCategories: [],
		categoryMap:{},
		loadingInput:true
	}

	constructor(props){
		super(props);
		this.checkValidInput = debounce(this.checkValidInput, 600);
	}

	componentWillReceiveProps(nextProps){

		if(nextProps.visible && !this.props.visible){
			setTimeout( () => {
				this.setState({
					loadingInput:false
				})
			}, 0);
		}

		if(!nextProps.visible && this.props.visible){
			setTimeout( () => {
				this.setState({
					loadingInput:true
				})
			}, 0);
		}

		if(!nextProps.visible && this.props.visible){
			
		}

		if(nextProps.categories.data){

			const categoryMap = nextProps.categories.data.reduce( (acc,cur) => {

				acc = {
					...acc,
					[cur.title.toLowerCase()]: true,
					...cur.children.reduce( (subAcc, sucCur) => {

						subAcc[sucCur.title.toLowerCase()] = true;

						return subAcc;
					}, {})
				}

				return acc;
			}, {})

			this.setState({
				categoryMap
			})
		}

	}

	checkValidInput = (value) => {

		this.searchCategories(value)
			.then( res => {
				this.setState({
					existingCategories: res.data.categories
				})
			})

	}

	handleOnChange = (e) => {
		const { categoryMap } = this.state;
		
		if(categoryMap[e.target.value.toLowerCase()]){
			this.props.onErrorHandler(true);
		} else {
			this.props.onErrorHandler(false);
		}

		this.checkValidInput(e.target.value);
		this.props.onChange(e)
	}

	searchCategories = (searchValue) => {
		return axios({
			url: `${URL_ENDPOINT}/api/category/search/${searchValue}`,
			withCredentials: true
		})
	}

}

export default connect(
	state => ({
		categories: state.categories
	})
)(AddCategoryModal);


// WEBPACK FOOTER //
// ./src/components/category/add-category-modal.js